/* =============================================================================
   "AVISA-ME QUANDO VOLTAR" — o comportamento, num sítio só.

   ⚠️ ESTE FICHEIRO É O ÚNICO DONO desta caixa. A marcação está em
   `snippets/ilha-avisa-me.liquid` e os dois modelos de página usam ambos:
     · a ITP  (`templates/product.ilha.liquid`)      — 657 produtos
     · o antigo (`snippets/buy-buttons.liquid`)      — 2 753 produtos
   Antes disto a caixa só existia dentro da ITP, e nos outros 2 753 quem punha o
   botão E o formulário era o Klaviyo. Silva, 4/09/2026: *"o que é nosso é só
   aquele botão."* Tinha razão.

   ⛔ NÃO DUPLICAR ISTO. Se um dia parecer mais fácil copiar a caixa para outro
   modelo, é sinal de que se deve chamar o snippet a partir de lá.
   ========================================================================== */
(function () {
  'use strict';
  if (window.IlhaAvisaMe) return;                 // já ligado nesta página

  var PORTA = 'https://contas.ilhadoscosmeticos.pt/reposicao/avisar-me';

  var caixa, abrirBt, painel, enviarBt, campo, aviso, linhaInput, intro,
      opcao, marca, textoConsent, pequena, dados = null, actual = null, rotulo = 'Avisa-me';

  function $(id) { return document.getElementById(id); }

  function apanhar() {
    caixa = $('itpBis'); abrirBt = $('itpBisOpen'); painel = $('itpBisPanel');
    enviarBt = $('itpBisSend'); campo = $('itpBisEmail'); aviso = $('itpBisMsg');
    linhaInput = $('itpBisInputRow'); intro = $('itpBisLead'); opcao = $('itpBisOptRow');
    marca = $('itpBisNovidades'); textoConsent = $('itpBisConsentimento'); pequena = $('itpBisFine');
    return !!(caixa && abrirBt && enviarBt && campo);
  }

  function dizer(txt, bem) {
    if (!aviso) return;
    aviso.textContent = txt; aviso.hidden = false;
    aviso.className = 'bis-msg ' + (bem ? 'ok' : 'err');
  }

  /* ⚠️ O botão de abrir NÃO se esconde: ele é agora o botão principal do produto
     esgotado (substitui o "Esgotado"), e a caixa abre POR CIMA, numa janela. */
  function abrir() {
    if (!painel) return;
    painel.hidden = false;
    document.addEventListener('keydown', escapar);
    if (campo) { try { campo.focus({ preventScroll: true }); } catch (e) { campo.focus(); } }
  }

  function fechar() {
    if (painel) painel.hidden = true;
    document.removeEventListener('keydown', escapar);
    if (abrirBt) { try { abrirBt.focus({ preventScroll: true }); } catch (e) {} }
  }

  function escapar(ev) { if (ev.key === 'Escape') fechar(); }

  /* Repõe a caixa ao estado inicial. ⚠️ Inclui a linha do consentimento e a letra
     pequena: o envio com sucesso esconde-as, e sem as repor, mudar de tom depois
     de um pedido deixava a pessoa sem poder dizer que sim ao tom seguinte. */
  function repor() {
    if (abrirBt) abrirBt.hidden = false;
    if (painel) painel.hidden = true;
    document.removeEventListener('keydown', escapar);
    if (linhaInput) linhaInput.hidden = false;
    if (intro) intro.hidden = false;
    if (opcao) opcao.hidden = false;
    if (pequena) pequena.hidden = false;
    if (aviso) aviso.hidden = true;
    if (enviarBt) { enviarBt.disabled = false; enviarBt.textContent = rotulo; }
  }

  function feito() {
    /* ⚠️ Mostra-se sempre o mesmo, mesmo quando ela já tinha pedido este produto
       (`ja_pedido`). Dizer-lhe "já tinhas pedido" não lhe serve de nada. */
    if (linhaInput) linhaInput.hidden = true;
    if (intro) intro.hidden = true;
    if (opcao) opcao.hidden = true;
    if (pequena) pequena.hidden = true;
    dizer('✓ Prontinho! Avisamos-te por email assim que este produto voltar.', true);
    /* fecha-se sozinha, para ela não ter de procurar o × depois de já estar feito */
    setTimeout(function () { if (painel && !painel.hidden) fechar(); }, 2600);
  }

  function falhou() {
    if (enviarBt) { enviarBt.disabled = false; enviarBt.textContent = rotulo; }
    dizer('Não foi possível registar agora. Tenta daqui a pouco, ou fala connosco pelo chat.', false);
  }

  /* A ponte para o Klaviyo saiu a 19/09/2026: a conta foi apagada e o widget dele também.
     Se a porta da Nortada falhar, a caixa diz que não deu, em vez de fingir que guardou
     o pedido num sítio que já não existe. (Pedido da Nortada de 17/09.) */

  function enviar() {
    var mail = (campo.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail)) { dizer('Escreve um email válido, por favor.', false); campo.focus(); return; }
    var v = actual;
    if (!v || !v.id) { dizer('Não foi possível identificar o produto. Recarrega a página.', false); return; }
    /* ⚠️ O SKU é da VARIANTE. Sem ele a Nortada recusa com `sem_sku` — e numa
       coloração de 94 tons, o SKU do produto avisava a pessoa do tom errado. */
    if (!v.sku) { dizer('Este produto não pode ser avisado por agora. Fala connosco pelo chat.', false); return; }

    enviarBt.disabled = true; enviarBt.textContent = 'A enviar…';
    fetch(PORTA, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: mail,
        sku: v.sku,
        produtoId: String(dados.produtoId),
        varianteId: String(v.id),
        nomeProduto: dados.produtoNome + (v.t && v.t !== 'Default Title' ? ' ' + v.t : ''),
        preco: ((v.p || 0) / 100).toFixed(2),
        origem: 'pagina-de-produto',
        quereNovidades: !!(marca && marca.checked),
        /* ⚠️ A prova sai do ECRÃ, não do código: é a frase que ela mesma leu.
           Assim as duas não se podem separar, em vez de "não se devem". */
        textoConsentimento: textoConsent ? (textoConsent.textContent || '').trim() : ''
      })
    }).then(function (r) {
      if (r.status === 201 || r.status === 200) { feito(); return; }
      if (r.status === 429) { enviarBt.disabled = false; enviarBt.textContent = rotulo;
        dizer('Já registámos há pouco. Espera um bocadinho e tenta outra vez.', false); return; }
      falhou();
    }).catch(falhou);
  }

  /* Diz à caixa qual é a variante escolhida. Chamada pela ITP quando o tom muda,
     e pelo próprio ficheiro quando é o modelo antigo a mandar. */
  function definirVariante(id) {
    if (!dados) return;
    var achou = null;
    for (var i = 0; i < dados.variantes.length; i++) {
      if (String(dados.variantes[i].id) === String(id)) { achou = dados.variantes[i]; break; }
    }
    if (!achou) return;
    var mudou = !actual || String(actual.id) !== String(achou.id);
    actual = achou;
    if (caixa) caixa.hidden = !!achou.a;          // com stock, a caixa não aparece
    if (mudou && !achou.a) repor();
  }

  function arrancar() {
    /* ⚠️⚠️ A MESMA CAIXA PODE VIR DUAS VEZES NA PÁGINA, e vinha (07/09/2026).
       O `buy_buttons` é um BLOCO do tema e a ficha de produto tem DOIS configurados,
       por isso o snippet é desenhado duas vezes. Resultado: dois botões "Avisa-me"
       iguais, ids repetidos, e o segundo morto — o `getElementById` só devolve o
       primeiro, logo o outro ficava a não fazer nada quando lhe tocassem.
       ⚠️ Não se resolve na configuração do tema: o segundo bloco pode ser de
       propósito e amanhã há um terceiro. Resolve-se aqui, e fica resolvido. */
    var repetidas = document.querySelectorAll('#itpBis');
    for (var i = 1; i < repetidas.length; i++) repetidas[i].remove();
    var dados2 = document.querySelectorAll('#itpBisDados');
    for (var j = 1; j < dados2.length; j++) dados2[j].remove();

    if (!apanhar()) return;
    var bruto = $('itpBisDados');
    if (!bruto) return;
    try { dados = JSON.parse(bruto.textContent); } catch (e) { return; }
    if (!dados || !dados.variantes || !dados.variantes.length) return;

    /* ⚠️ O rótulo do botão lê-se do PRÓPRIO BOTÃO, uma vez. Já esteve escrito em
       três sítios e um deles repunha a versão antiga por cima da nova. */
    rotulo = (enviarBt.textContent || 'Avisa-me').trim();

    abrirBt.addEventListener('click', abrir);
    var xis = $('itpBisX');
    if (xis) xis.addEventListener('click', fechar);
    /* clicar no escuro à volta também fecha — só no escuro, não na caixa */
    painel.addEventListener('click', function (ev) { if (ev.target === painel) fechar(); });
    enviarBt.addEventListener('click', enviar);
    campo.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') { ev.preventDefault(); enviar(); }
    });

    definirVariante(dados.escolhida);

    /* No modelo antigo quem manda na variante é o `[name="id"]` do formulário do
       carrinho. Na ITP é a própria ITP que chama `definirVariante`. */
    if (!dados.itp) {
      var form = document.querySelector('form[action*="/cart/add"]');
      var campoId = form && form.querySelector('[name="id"]');
      if (form && campoId) {
        form.addEventListener('change', function () { definirVariante(campoId.value); });
        setInterval(function () {
          if (campoId.value && (!actual || String(actual.id) !== String(campoId.value))) definirVariante(campoId.value);
        }, 700);
      }
    }
  }

  window.IlhaAvisaMe = { abrir: abrir, repor: repor, definirVariante: definirVariante };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
